// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The parts of the scenario browse card keyed off its kind.
 *
 * The layout is ../catalog/CatalogBrowseLayout.module.css, shared with the
 * other browse pages; only kind-keyed rules live here, the split
 * ModelCatalogBrowseCard.module.css uses.
 *
 * ONE key, not one per scenario: on this page every card is a scenario. The
 * scenario's own colour, the one its boxes wear on the canvas, is the square
 * before the card's name. See --curio-kind-scenario-fg.
 */

.W8ny4dMBtQCuYHRETaJl { background: var(--curio-kind-scenario-fg); }

/* The project's graph, at a fixed height: a box sized by its contents would
   let the drawing's 100% height grow the card past what it shows. */
.BsF4tA1OESQnQPauLhDB {
  height: 84px;
  flex-shrink: 0;
  overflow: hidden;
  border-bottom: 1px solid var(--curio-page-bg);
}

/* Declared here so \`.cardActive.card_scenario\` is a valid compound WITHIN
   this module: CSS modules hash per file, so the shared \`.cardActive\` cannot
   satisfy it. Both classes are applied together and agree. */
.at5PHUyX1UMCcIpMAyHw { box-shadow: var(--curio-shadow-browse-card-raised); }
.at5PHUyX1UMCcIpMAyHw.bnEWJ2i8Xw6VRWif_7LX { border-color: var(--curio-kind-scenario-fg); }
`, "",{"version":3,"sources":["webpack://./src/pages/scenarios/ScenarioCatalogBrowseCard.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF,wBAAkB,yCAAyC,EAAE;;AAE7D;oEACoE;AACpE;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;;6DAE6D;AAC7D,wBAAc,kDAAkD,EAAE;AAClE,6CAA4B,2CAA2C,EAAE","sourcesContent":["/*\n * The parts of the scenario browse card keyed off its kind.\n *\n * The layout is ../catalog/CatalogBrowseLayout.module.css, shared with the\n * other browse pages; only kind-keyed rules live here, the split\n * ModelCatalogBrowseCard.module.css uses.\n *\n * ONE key, not one per scenario: on this page every card is a scenario. The\n * scenario's own colour, the one its boxes wear on the canvas, is the square\n * before the card's name. See --curio-kind-scenario-fg.\n */\n\n.strip_scenario { background: var(--curio-kind-scenario-fg); }\n\n/* The project's graph, at a fixed height: a box sized by its contents would\n   let the drawing's 100% height grow the card past what it shows. */\n.thumbnail {\n  height: 84px;\n  flex-shrink: 0;\n  overflow: hidden;\n  border-bottom: 1px solid var(--curio-page-bg);\n}\n\n/* Declared here so `.cardActive.card_scenario` is a valid compound WITHIN\n   this module: CSS modules hash per file, so the shared `.cardActive` cannot\n   satisfy it. Both classes are applied together and agree. */\n.cardActive { box-shadow: var(--curio-shadow-browse-card-raised); }\n.cardActive.card_scenario { border-color: var(--curio-kind-scenario-fg); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"strip_scenario": `W8ny4dMBtQCuYHRETaJl`,
	"thumbnail": `BsF4tA1OESQnQPauLhDB`,
	"cardActive": `at5PHUyX1UMCcIpMAyHw`,
	"card_scenario": `bnEWJ2i8Xw6VRWif_7LX`
};
export default ___CSS_LOADER_EXPORT___;
